export const BOARD_TYPE_BALANCE_TO_PAY = "SALDOPORPAGAR";
export const BOARD_TYPE_BALANCE_TO_COLLECT = "SALDOPORCOBRAR";
export const BOARD_TYPE_PROFIT = "LUCRO";

export const BOARD_PROCESS_STATUS_SP = "dbo.S10_00_TableroProcesar_ListarEstado";
export const BOARD_PROCESS_EXECUTE_SP = "dbo.S10_00_TableroProcesar_Ejecutar";

export const BOARD_PROCESS_WAIT_TIME_MS = 10 * 60 * 1000;
export const BOARD_PROCESS_SUMMARY_REFRESH_MS = 5 * 1000;
export const BOARD_PROCESS_WAIT_REFRESH_MS = 30 * 1000;

export const BOARD_TYPE_LABELS: Record<string, string> = {
  [BOARD_TYPE_BALANCE_TO_PAY]: "Saldos por Pagar",
  [BOARD_TYPE_BALANCE_TO_COLLECT]: "Saldos por Cobrar",
  [BOARD_TYPE_PROFIT]: "Lucro",
};

export const BOARD_TYPES_WITH_PROJECT = [BOARD_TYPE_PROFIT];

export const boardTypeUsesProject = (tipoTablero: string): boolean =>
  BOARD_TYPES_WITH_PROJECT.includes(tipoTablero);

export const buildBoardProcessKey = (tipoTablero: string, codProyecto?: string | null): string => {
  const project = (codProyecto || "").trim();
  return boardTypeUsesProject(tipoTablero) && project
    ? `${tipoTablero}|${project.toUpperCase()}`
    : tipoTablero;
};
